<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left;"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.audioPlayTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放打谱
        </el-col>
        <el-col :span="24" class="imgStyle" align="left" v-loading="loadingIframe">
            <iframe
                :id="`Inknote${serial}`"
                ref="Inknote"
                :src="`${inknoteUrl}/inknote/index.html?Serial=Inknote-${serial}`"
                frameborder="0"
                style="height:100%;width:100%;"
            ></iframe>
        </el-col>
    </div>
</template>
<script>
import utils, { json_P } from '../../lib/util'
import audioStyle from '../../components/audioStyle'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"clefTopic",
        props: {
            sonData: Object,
            allAnswer:Object,
            serial:Number,
            buttonNum:Number,
        },
        data() {
            return {
                inknoteUrl:'',
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                loadingIframe:true,
                submitNum:0,
                beatVal:'',
                beatImgUrl:'',
                plays:0,
                answerType:null,
            }
        },
        components:{audioStyle},  
        watch: {
            'beatVal':function(now,old){
                if(now&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
            },
            'plays':function(now,old){
                this.$emit('storeLocally')
            },
        },
        mounted(){
            let that = this
            that.inknoteUrl = process.env.INKNOTE_URL
            that.heart = that.sonData
            if(!that.heart.audioPlayTime) that.heart.audioPlayTime = -1
            that.plays = utils.mottoClone(that.heart.audioPlayTime)
            that.submitNum = utils.mottoClone(that.heart.submitNum)
            that.$nextTick(function(){
                if(that.allAnswer){
                    that.beatVal = that.allAnswer.obj.beatVal
                    that.plays = that.allAnswer.playss
                    that.submitNum = that.allAnswer.submitNum
                    that.answerType = that.allAnswer.obj.answerType
                }

                that.iframeLoading()

                // 接受
                window.addEventListener('message',function(e){
                    if(e.data&&e.data.type){
                        if(e.data.type == 'start'){
                            if(e.data.serial == that.serial)
                            that.sendIframeMsg()
                        }
                        else if(e.data.type == 'save'){
                            if(e.data.content&&e.data.content.length>0)
                            that.iframeEmit(e.data)
                        }
                    }
                },false);  
            })
        },
        methods:{
            //接受Inknote的值
            iframeEmit(inknoteData){
                if(inknoteData&&inknoteData.serial.split('-')[1]==this.serial){
                    if(
                        inknoteData.content[0].instruments&&
                        inknoteData.content[0].instruments[0]
                    ){//有曲谱数据
                        this.$set(this,'beatVal',inknoteData.content)
                        this.$nextTick(()=>{
                            wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                                allData:this.$parent.allData,
                                uuid1:this.$parent.uuid1,
                                firstStartDateVal:this.$parent.firstStartDateVal,
                            })
                        })
                    }
                }
            },
            sendIframeMsg(){
                //发送
                let iframeIn = document.getElementById(`Inknote${this.serial}`)
                iframeIn.contentWindow.postMessage({
                    data:this.beatVal,
                    serial:this.serial,
                    tempoUnit:this.heart.tempoUnit,
                },'*');
            },
            iframeLoading(){
                var that = this
                const iframe = document.getElementById(`Inknote${this.serial}`)
                // 处理兼容行问题
                if (iframe.attachEvent) {
                    iframe.attachEvent('onload', function () {
                        that.loadingIframe = false
                        console.log('iframe加载完成')
                    })
                } else {
                    iframe.onload = function () {
                        that.loadingIframe = false
                        console.log('iframe加载完成')
                    }
                }
            },
            startPlaying(){},
            endPlaying(){
                if(this.plays<=0) this.plays==-1? this.plays=-1:this.plays=0
                else this.plays--;
            },
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.audioPlayTime)
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        position: relative;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            position: absolute;
            top: 0;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            position: absolute;
            top: 33px;
            height: 22px;
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            position: absolute;
            top: 55px;
            left: 0;
            bottom: 0;
            width: 100%;
            box-sizing: border-box;
            padding: 10px;
            
        }
        @media only screen and (max-height: 713px) {
            .imgStyle{
                padding: 30px 18px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/clefTopic.vue